import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import useAppSelector from "@/core/helpers/useAppSelector";
import { useKeyPress } from "@/core/keyPressManager";
import { keyCodeLabel } from "@/shared/constants/keyCodeLabel";
import { Color } from "@/domains/dialogue/constants/color";
import { playerInfoSelector } from "@/domains/player/slice";
import useShowDialogue from "@/domains/dialogue/hooks/useShowDialogue";
import DialogueNpcMessage from "@/domains/dialogue/components/DialogueNpcMessage";
import DialogueSelfMessage from "@/domains/dialogue/components/DialogueSelfMessage";
import KeyCode from "@/assets/constants/key-code";

function DialogueContainer() {
  const { t } = useTranslation("ped");
  const { dialogue, options, isShow, handleSelectOption } = useShowDialogue();
  const playerInfo = useAppSelector(playerInfoSelector);
  const [currKeyOption, setCurrKeyOption] = useState<number | null>(null);
  const { subscribeKeyDown, subscribeKeyUp, unsubscribeKeyDown, unsubscribeKeyUp } = useKeyPress();

  useEffect(() => {
    const key = "option-key-down";

    subscribeKeyDown(key, (keyCode) => {
      switch (keyCode) {
        case KeyCode.KEY_0:
        case KeyCode.KEY_1:
        case KeyCode.KEY_2:
        case KeyCode.KEY_3:
        case KeyCode.KEY_4:
        case KeyCode.KEY_5:
        case KeyCode.KEY_6:
        case KeyCode.KEY_7:
        case KeyCode.KEY_8:
        case KeyCode.KEY_9:
          setCurrKeyOption(Number(keyCodeLabel[keyCode]));
          break;
        default:
          setCurrKeyOption(null);
      }
    });

    return () => {
      unsubscribeKeyDown(key);
    };
  }, [subscribeKeyDown, unsubscribeKeyDown]);

  useEffect(() => {
    const key = "option-key-up";

    subscribeKeyUp(key, () => {
      setCurrKeyOption(null);
    });

    return () => {
      unsubscribeKeyUp(key);
    };
  }, [subscribeKeyUp, unsubscribeKeyUp]);

  if (!isShow) return null;

  return (
    <div
      className={clsx(
        "absolute inset-y-[--boundary-offset-y] inset-x-[--boundary-offset-x] flex flex-col justify-center items-center",
      )}
    >
      <div className="w-[40%] w-max-[40rem] flex flex-col gap-5">
        <DialogueNpcMessage
          color={Color.Green}
          subject={t(`ped.dialogs.${dialogue.dialog.localizationKey}.title`)}
          text={t(`ped.dialogs.${dialogue.dialog.localizationKey}.text`)}
        />
        <DialogueSelfMessage
          fullName={playerInfo ? playerInfo.character.name.content : "Incognito"}
          color={Color.Green}
          className="place-self-end"
          options={options}
          onClickOption={handleSelectOption}
          activeOptionId={currKeyOption || undefined}
        />
      </div>
    </div>
  );
}

export default DialogueContainer;
